export default function () {
  const searchForms: NodeList = document.querySelectorAll(
    ".site-header__search--desktop > form"
  );
  if (searchForms) {
    searchForms.forEach((searchForm) => {
      const sf = searchForm as HTMLElement;
      const submitButton: HTMLElement | null = sf.querySelector("button");
      if (submitButton) {
        const tabletActivator = submitButton.cloneNode(true) as HTMLElement;
        const input: HTMLInputElement | null = sf.querySelector("input");
        if (tabletActivator) {
          tabletActivator.classList.add("search-submit--tablet-activator");
          tabletActivator.setAttribute("aria-label", "Search");
          tabletActivator.setAttribute("aria-controls", "search-form");
          tabletActivator.setAttribute("aria-expanded", "false");
          tabletActivator.setAttribute("type", "button");
          searchForm.appendChild(tabletActivator);
          tabletActivator.addEventListener("click", () => {
            if (sf.classList.contains("search-form--active")) {
              closeInput(sf, tabletActivator);
            } else {
              openInput(sf, input, tabletActivator);
            }
          });
        }
        sf.addEventListener("keydown", (e) => {
					// console.log('a', e.key)
          if (e.key === "Escape") {
						closeInput(sf, tabletActivator);
          }
        });
				document.addEventListener("click", (e) => {
					if (!sf.contains(e.target as Node)) {
						closeInput(sf, tabletActivator);
						removeEventListener("click", () => {});
					}
				});
      }
    });
  }

  function openInput(
		sf: HTMLElement,
    input: HTMLInputElement | null,
    tabletActivator: HTMLElement
  ) {
		// console.log('c')
		sf.classList.add("search-form--active");
    input?.focus();
    tabletActivator?.setAttribute("aria-expanded", "true");
  }
  function closeInput(
		sf: HTMLElement,
    tabletActivator: HTMLElement
  ) {
    sf.classList.remove("search-form--active");
    tabletActivator?.setAttribute("aria-expanded", "false");
  }
}
